/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AppVersionCreate
 */
export interface AppVersionCreate {
    /**
     * 
     * @type {Array<number>}
     * @memberof AppVersionCreate
     */
    notification_days?: Array<number> | null;
    /**
     * 
     * @type {boolean}
     * @memberof AppVersionCreate
     */
    required: boolean;
    /**
     * 
     * @type {number}
     * @memberof AppVersionCreate
     */
    rollout_timestamp?: number | null;
    /**
     * 
     * @type {number}
     * @memberof AppVersionCreate
     */
    version: number;
    /**
     * 
     * @type {string}
     * @memberof AppVersionCreate
     */
    object_type: string;
}

/**
 * Check if a given object implements the AppVersionCreate interface.
 */
export function instanceOfAppVersionCreate(value: object): value is AppVersionCreate {
    if (!('required' in value) || value['required'] === undefined) return false;
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    return true;
}

export function AppVersionCreateFromJSON(json: any): AppVersionCreate {
    return AppVersionCreateFromJSONTyped(json, false);
}

export function AppVersionCreateFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppVersionCreate {
    if (json == null) {
        return json;
    }
    return {
        
        'notification_days': json['notification_days'] == null ? undefined : json['notification_days'],
        'required': json['required'],
        'rollout_timestamp': json['rollout_timestamp'] == null ? undefined : json['rollout_timestamp'],
        'version': json['version'],
        'object_type': json['object_type'],
    };
}

export function AppVersionCreateToJSON(json: any): AppVersionCreate {
    return AppVersionCreateToJSONTyped(json, false);
}

export function AppVersionCreateToJSONTyped(value?: AppVersionCreate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'notification_days': value['notification_days'],
        'required': value['required'],
        'rollout_timestamp': value['rollout_timestamp'],
        'version': value['version'],
        'object_type': value['object_type'],
    };
}

